import { render, staticRenderFns } from "./HeaderServicio.vue?vue&type=template&id=629d2054&"
import script from "./HeaderServicio.vue?vue&type=script&lang=js&"
export * from "./HeaderServicio.vue?vue&type=script&lang=js&"
import style0 from "./HeaderServicio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports